export const TBL_HEADERS = [
  {
    name: "Actions",
    variable: "",
  },
  {
    name: "File",
    variable: "testName",
  },
  {
    name: "Instrument",
    variable: "testType",
  },
  {
    name: "Drug Class",
    variable: "labId",
  },
  {
    name: "Specimen Type",
    variable: "resultMethod",
  },
  {
    name: "QC Level",
    variable: "testCode",
  },
  {
    name: "QC Result",
    variable: "orderCode",
  },
  {
    name: "QC Lot Expiration",
    variable: "tmitCode",
  },
];
